// Dummy data for restaurant status tabs (Pending, Suspended, Appeal)

export interface PendingRestaurant {
  id: string;
  name: string;
  image: string;
  applicationDate: string;
  status: "pending" | "missing_documents";
  documents?: string[];
}

export interface SuspendedRestaurant {
  id: string;
  name: string;
  suspensionReason: string;
  suspensionDate: string;
  walletBalance: number;
  status: "suspended";
}

export interface AppealRestaurant {
  id: string;
  name: string;
  appealReason: string;
  submittedDate: string;
  status: "under_review" | "pending_review";
  attachments?: string[];
}

export const pendingRestaurantsData: PendingRestaurant[] = [
  {
    id: "PENDING001",
    name: "The Place Gbagada",
    image: "/assets/picture.jpg",
    applicationDate: "2hrs Ago",
    status: "pending",
    documents: ["Business License", "Food Safety Certificate"]
  },
  {
    id: "PENDING002",
    name: "Pizza Palace",
    image: "/assets/picture.jpg",
    applicationDate: "1 day Ago",
    status: "missing_documents",
    documents: ["Tax Certificate"]
  },
  {
    id: "PENDING003",
    name: "Mama's Kitchen",
    image: "/assets/picture.jpg",
    applicationDate: "3 days Ago",
    status: "pending",
    documents: ["Business Registration", "Health Certificate"]
  }
];

export const suspendedRestaurantsData: SuspendedRestaurant[] = [
  {
    id: "FOOD001",
    name: "FOOD pLACE",
    suspensionReason: "Price mismatch reported",
    suspensionDate: "29 - 09- 2026",
    walletBalance: 3400,
    status: "suspended"
  },
  {
    id: "FOOD002", 
    name: "Quick Bite",
    suspensionReason: "Multiple customer complaints",
    suspensionDate: "25 - 09- 2026",
    walletBalance: 1200,
    status: "suspended"
  },
  {
    id: "FOOD003",
    name: "Spice Garden",
    suspensionReason: "Health code violations",
    suspensionDate: "20 - 09- 2026", 
    walletBalance: 5600,
    status: "suspended"
  }
];

export const appealRestaurantsData: AppealRestaurant[] = [
  {
    id: "APPEAL001",
    name: "The Place Gbagada",
    appealReason: "We have resolved all customer service issues and implemented new quality control measures....",
    submittedDate: "11-12-2026",
    status: "under_review",
    attachments: ["quality_control_plan.pdf", "customer_feedback_improvements.pdf"]
  },
  {
    id: "APPEAL002",
    name: "Golden Spoon",
    appealReason: "Upgraded kitchen facilities and hired certified food safety manager....",
    submittedDate: "10-12-2026",
    status: "pending_review",
    attachments: ["health_certificate_renewal.pdf", "staff_training_records.pdf"]
  }
];

// Dummy restaurant details for modals
export const restaurantDetails = {
  "PENDING001": {
    name: "The Place Gbagada",
    phone: "0980 234 4567",
    email: "theplace@gmail.com",
    location: "No 5 Aganmu, Lagos State",
    applicationDate: "Jan 18, 2025",
    documents: ["Business License", "Food Safety Certificate", "Tax ID"],
    status: "pending",
    type: "pending" as const
  },
  "FOOD001": {
    name: "The Place Restaurant", 
    phone: "0980 234 4567",
    email: "Theplace@gmail.com",
    location: "No 5 Aganmu, Lagos State",
    status: "Suspended",
    type: "suspended" as const,
    accountSuspended: {
      date: "Jan 18, 2025",
      reason: "Multiple policy violations and poor customer service ratings",
      walletBalance: 67000,
      payoutNote: "(Payout requests require approval)"
    },
    stats: {
      rate: "3.2/5.0",
      totalOrder: "456",
      revenue: "₦560K"
    }
  },
  "APPEAL001": {
    name: "Appeal Review- The Place Gbagada",
    description: "Review Restaurant appeal and make a decision",
    appealReason: "We have resolved all customer service issues and implemented new quality control measures",
    dateSubmitted: "12-12-2025",
    status: "Under Review",
    attachments: ["quality_improvements.pdf"],
    type: "appeal" as const
  }
};
